const storeKey = 'smartClip'
export function saveDataStorage(key: string, value: any) {
  const data = getDataStorage()
  const info = {
    ...data,
    [key]: value
  }
  const dataStr = JSON.stringify(info)
  localStorage.setItem(storeKey, dataStr)
}

export function getDataStorage(key: string = '') {
  const data = JSON.parse(localStorage.getItem(storeKey)) || {}
  return key ? data[key] : data;
}